import { CmsParams } from '@/lib/cms-params.type';
import { Access } from '@/lib/access.enum';

export function isAuthenticated(params: CmsParams): boolean {
  return params.access === Access.user;
}
